// color接口声明文件

import requestColor from '@/utils/requestColor';

// 获取云配跳转URL - 判断门店是否满足合作伙伴条件并返回相应URL
// https://j-api.jd.com/fe-app-view/demandManage/25301?branchId=37824&interfaceType=1&methodId=4414278
export const apiGetYunPaiPartnerUrl = async (params) => {
  return requestColor('/getYunPaiPartnerUrl', {
    method: 'get',
    params: {
      functionId: 'getYunPaiPartnerUrl',
      body: params,
    },
  });
};

export const demo = 1;
